export const FormSamplesFormGroupsPageInfo = () => {
    return (
        <>
            Sometimes forms require a grouping of inputs, or an array of inputs.<br />
            Consider this json.<br />
            <br />
            {'{'}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;departmentId: 4,<br />
            &nbsp;&nbsp;&nbsp;&nbsp;departmentDesc: "Marketing",<br />
            &nbsp;&nbsp;&nbsp;&nbsp;manager: {'{'}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;personId: 228,<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;firstName: 'Peter', lastName: 'Piper', email: 'ppiper@test.com',<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;carLeases: {'['}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'} carLeaseId: 402, make: 'Toyota', model: 'Yaris', fromYear: 2002, toYear: 2008 {'}'},<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'} carLeaseId: 404, make: 'Nissan', model: 'Leaf', fromYear: 2008, toYear: 2012 {'}'}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{']'}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
            &nbsp;&nbsp;&nbsp;&nbsp;supervisor: {'{'}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;personId: 246,<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;firstName: 'Karl', lastName: 'Johnson', email: 'kjohnson@test.com'<br />
            &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
            {'}'}<br />
            <br />
            departmentDesc can be mapped to a TextInput, but manager and supervisor require something more complex. <br />
            That's where FormGroups come in. A FormGroup is created in a component called FormSamplesFormGroupsFGPerson. <br />
            Now look at the carLeases in the json above, it is an array. A FormGroupArray is created in a component called
            FormSamplesFormGroupsFGCarLeases which will handle this.<br />
            Refer to the comments in these components for more information and how to impliment this.
        </>
    )
}
